import {TanStackCachePreheatContextProvider as Provider} from '@github-ui/relay-query-cache/contexts/RelayCachePreheatContext'
import type {ComponentProps} from 'react'

export function TanStackCachePreheatContextProvider(props: ComponentProps<typeof Provider>) {
  return <Provider {...props} />
}
